module.exports = __webpack_public_path__ + "img/the-legend-of-zelda.796f41fe.png";